/**
 * Contact Page - Google Map
 * Initializes a Google Map with markers for all Jaeckle locations
 */

function initContactMap() {
	const container = document.getElementById('contact-map');
	if (!container || !window.jaeckleLocations?.length) {
		return;
	}

	const locations = window.jaeckleLocations;

	const map = new google.maps.Map(container, {
		zoom: 5,
		center: { lat: 43.0, lng: -89.4 },
		mapTypeControl: false,
		streetViewControl: false,
	});

	const bounds = new google.maps.LatLngBounds();
	let openInfoWindow = null;

	locations.forEach(location => {
		const position = { lat: location.lat, lng: location.lng };

		const marker = new google.maps.Marker({
			position: position,
			map: map,
			title: location.title,
		});

		const infoContent = `
			<div style="padding: 4px 0; min-width: 160px;">
				<strong style="font-size: 14px;">${location.title}</strong>
				${location.address ? `<br><span style="font-size: 13px; color: #555;">${location.address}</span>` : ''}
				${location.city ? `<br><span style="font-size: 13px; color: #555;">${location.city}${location.state ? ', ' + location.state : ''}</span>` : ''}
			</div>
		`;

		const infoWindow = new google.maps.InfoWindow({
			content: infoContent,
		});

		marker.addListener('click', () => {
			if (openInfoWindow) {
				openInfoWindow.close();
			}
			infoWindow.open(map, marker);
			openInfoWindow = infoWindow;
		});

		bounds.extend(position);
	});

	if (locations.length > 1) {
		map.fitBounds(bounds);
	} else if (locations.length === 1) {
		map.setCenter({ lat: locations[0].lat, lng: locations[0].lng });
		map.setZoom(12);
	}
}

// Initialize once DOM is ready (Google Maps API is loaded as a dependency)
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initContactMap);
} else {
	initContactMap();
}
